import http from './http-util'
import { appendQueryParam } from './api-util'
import config from '../../../config'

const appendParam = (queryString, param) => {
  let result = queryString
  if (param) {
    if (queryString.length) {
      result = `${queryString}&${param.buildParam()}`
    } else {
      result = `?${param.buildParam()}`
    }
  }
  return result
}

const buildQueryParams = (pageInfo, searchInfo, activeInfo) => {
  let queryString = ''
  queryString = appendParam(queryString, pageInfo)
  queryString = appendParam(queryString, searchInfo)
  queryString = appendParam(queryString, activeInfo)
  return queryString
}

class UserServiceApi {
  static getUsers = (requestData, token) => {
    if (
      requestData.pageInfo != null &&
      (requestData.pageInfo.page < 0 ||
        requestData.pageInfo.page > requestData.totalPages - 1)
    ) {
      return null
    }

    const queryParams = buildQueryParams(
      requestData.pageInfo,
      requestData.searchInfo,
      requestData.activeInfo,
    )
    if (requestData.searchInfo && requestData.searchInfo.search) {
      return http.get(
        token,
        `${config.userServiceUrl}/search/users${queryParams}`,
      )
    }
    return http.get(token, `${config.userServiceUrl}/users${queryParams}`)
  }

  static getMe = token => {
    return http.get(token, `${config.userServiceUrl}/me`)
  }

  static updateMe = (updateRequest, token) => {
    return http.put(token, `${config.userServiceUrl}/me`, updateRequest.user)
  }

  static getMeRepresentatives = token => {
    return http.get(token, `${config.userServiceUrl}/me/representatives`)
  }

  static searchMeRepresentatives =
    ({ pageInfo, searchInfo }) =>
    token => {
      let queryParams = pageInfo.buildParam()
      queryParams = appendQueryParam(
        queryParams,
        'search_term',
        searchInfo.search,
      )
      return http.post(
        token,
        `${config.userServiceUrl}/me/representatives/search?${queryParams}`,
      )
    }

  static getMeStores = (requestData, token) => {
    let queryParams = ''
    queryParams = appendQueryParam(
      queryParams,
      'representative_id',
      requestData.representativeId,
    )

    return http.get(token, `${config.userServiceUrl}/me/stores${queryParams}`)
  }

  static searchMeStores =
    ({ representativeId, pageInfo, searchInfo }) =>
    token => {
      let queryParams = pageInfo.buildParam()
      queryParams = appendQueryParam(
        queryParams,
        'search_term',
        searchInfo.search,
      )
      queryParams = appendQueryParam(
        queryParams,
        'representative_id',
        representativeId,
      )
      return http.post(
        token,
        `${config.userServiceUrl}/me/stores/search?${queryParams}`,
      )
    }

  static getUser = (id, token) => {
    return http.get(token, `${config.userServiceUrl}/users/${id}`)
  }

  static deleteUser = (id, token) => {
    return http.delete(token, `${config.userServiceUrl}/users/${id}`)
  }

  static saveUser = (user, token) => {
    return http.post(token, `${config.userServiceUrl}/users`, user)
  }

  static updateUser = (updateRequest, token) => {
    return http.put(
      token,
      `${config.userServiceUrl}/users/${updateRequest.id}`,
      updateRequest.user,
    )
  }

  static updateUserStores = (updateStoresRequest, token) => {
    return http.post(
      token,
      `${config.userServiceUrl}/users/${updateStoresRequest.id}/stores`,
      updateStoresRequest.stores,
    )
  }

  static updateUserAuthorities = (updateAuthoritiesRequest, token) => {
    return http.post(
      token,
      `${config.userServiceUrl}/users/${updateAuthoritiesRequest.id}/authorities`,
      updateAuthoritiesRequest.authorities,
    )
  }

  static confirmEmailChange = changeRequest => {
    return http.post(
      null,
      `${config.userServiceUrl}/users/email_confirmation`,
      JSON.stringify(changeRequest),
    )
  }

  static getUserStores = (requestData, token) => {
    let queryParams = ''
    queryParams = appendQueryParam(
      queryParams,
      'representative_id',
      requestData.representativeId,
    )

    return http.get(
      token,
      `${config.userServiceUrl}/users/${requestData.userId}/stores${queryParams}`,
    )
  }

  static getRoles = token => {
    return http.get(token, `${config.userServiceUrl}/roles`)
  }

  static exportStoreUsers = () => token => {
    return http.getBlobWithFilename(
      token,
      `${config.userServiceUrl}/export/users/active`,
    )
  }

  static exportRepresentativeUsers = () => token => {
    return http.getBlobWithFilename(
      token,
      `${config.userServiceUrl}/export/users/active/all`,
    )
  }
}

export default UserServiceApi
